



















import { Component, Prop, Vue } from 'vue-property-decorator';

import Tabs from '@/core/layout/Tabs/Tabs.vue';
import Tab from '@/core/layout/Tabs/Tab.vue';
import { ChangelogViewObject } from '@/types/apiServerContract';

@Component({
    components: { Tabs, Tab }
})
export default class ChangelogEntryLog extends Vue {
	@Prop({ required: false, type: String, default: 'div' }) tag!: string;
	@Prop({ required: true, type: Object }) log!: ChangelogViewObject;
}
